import { render, staticRenderFns } from "./RetirementOfPartners.vue?vue&type=template&id=1714191a&scoped=true&"
import script from "./RetirementOfPartners.vue?vue&type=script&lang=js&"
export * from "./RetirementOfPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1714191a",
  null
  
)

export default component.exports